import { View } from 'react-native';
import React from 'react';
import { Button, InsuranceCompanyLogo, Text } from '~/components';
// import StarRating from '~/components/StarRating';
import useMarisaAutoForm from '~/stores/marisaAutoForm';
import type { MarisaAuto } from '~/@types/MarisaAuto/form';
import { formatMoney } from '~/utils';

interface Props {
  insuranceQuote: MarisaAuto.InsuranceQuote;
  bestOffer: boolean;
  onContinue?: () => void;
}

const InsuranceQuoteCard = ({
  insuranceQuote,
  bestOffer,
  onContinue,
}: Props) => {
  const setSelectedInsuranceQuote = useMarisaAutoForm(
    (state) => state.setSelectedInsuranceQuote
  );

  return (
    <View
      className={`z-0 flex-row shadow-sm px-2 py-3 bg-white items-center
        mb-4 rounded-lg border border-solid justify-between
        ${bestOffer ? 'border-primary-600' : 'border-gray-200'}`}
    >
      <View className="flex-row justify-between flex-1">
        <View className="flex-row items-center">
          <InsuranceCompanyLogo name={insuranceQuote.empresaRefLogo} />
        </View>
        <View className="mx-1 bg-gray-100 w-[1px]" />

        <View className="flex-col justify-between flex-1">
          <Text
            className={`text-[12px] font-medium ${
              bestOffer ? 'text-primary-600' : 'text-gray-600'
            }`}
          >
            {bestOffer ? 'OFERTA RECOMENDADA' : insuranceQuote.nome}
          </Text>
          <View className="flex-row items-baseline">
            <Text className="text-gray-600  text-[10px] mr-1">
              Parcelas à partir de
              <Text className="text-gray-600 text-[10px] font-medium">
                {` R$${formatMoney(
                  insuranceQuote.bestPaymentOption.installmentValue
                )}* `}
              </Text>
              {`no ${insuranceQuote.bestPaymentOption.description}`}
            </Text>
          </View>
        </View>

        <Button
          className="px-2 py-2 text-xs justify-center"
          variant="secondary"
          onPress={() => {
            setSelectedInsuranceQuote(insuranceQuote);
            onContinue?.();
          }}
        >
          DETALHES
        </Button>
      </View>
      {/* <StarRating valueRating={parseInt(insuranceQuote.fatorFipe, 10)} /> */}
      {bestOffer && (
        <View className="rounded-full bg-primary-600 justify-center z-20 absolute top-[-12px] right-4">
          <Text className="text-white text-center font-bold text-[11px] my-1 mx-2">
            SEGURO CERTO
          </Text>
        </View>
      )}
    </View>
  );
};

export default InsuranceQuoteCard;
